import { type SVGProps } from 'react';

const SvgCircle = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={80}
      height={80}
      fill="currentColor"
      viewBox="0 0 80 80"
      role="img"
      aria-labelledby="circle"
      {...props}>
      <title id="circle-icon">circle icon</title>
      <path d="M41.885 79.955A39.994 39.994 0 0 1 3.611 56.608a40.003 40.003 0 0 1 7.443-44.214 39.992 39.992 0 0 1 43.808-9.527A40 40 0 0 1 79.99 40c.473 21.543-16.566 39.41-38.105 39.956m-.63-66.592a26.663 26.663 0 0 0-25.514 15.565 26.668 26.668 0 0 0 4.961 29.476 26.66 26.66 0 0 0 45.958-18.4c.32-14.366-11.042-26.283-25.404-26.646z" />
    </svg>
  );
};
export default SvgCircle;
